import {
    animate,
    animateChild,
    query,
    stagger,
    style,
    transition,
    trigger
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Message } from './Message';
import { ToastService } from './toast.service';
import { ToastButtons } from './ToastButtons';
import { ToastMessageType } from './ToastMessageType';
import { ToastResponse } from './ToastResponses';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: "aw-toast",
    templateUrl: "./toast.component.html",
    styleUrls: ["./toast.component.less"],
    animations: [
        trigger("list", [
            transition(":enter", [
                query("@items", stagger(300, animateChild()), { optional: true }),
            ]),
        ]),
        trigger("items", [
            transition(":enter", [
                style({ transform: "scale(0.5)", opacity: 0, "margin-top": "-165px" }), // initial
                animate("1s cubic-bezier(.8, -0.6, 0.2, 1.5)", style({ transform: "scale(1)", opacity: 1, "margin-top": "0px" })), // final
            ]),
            transition(":leave", [
                style({ transform: "scale(1)", opacity: 1, height: "*" }),
                animate("1s cubic-bezier(.8, -0.6, 0.2, 1.5)", style({
                    transform: "scale(0.5)",
                    opacity: 0,
                    height: "0px",
                    margin: "0px",
                })),
            ]),
        ]),
    ],
    imports: [NgClass, MatProgressBar, AsyncPipe]
})
export class ToastComponent implements OnInit {
  messages: Observable<Message[]>;
  Buttons = ToastButtons;
  ToastMessageType = ToastMessageType;
  responses = ToastResponse;
  showProgress = false;

  constructor(public toast: ToastService) {}

  ngOnInit() {
    this.messages = this.toast.getMessages();
  }
  
  trackBy = (_index: number, item: any) =>  item.Id

  dismiss(itemKey, result: ToastResponse) {
    this.toast.dismissMessage(itemKey, result);
  }

  relayMessage(itemKey, result: ToastResponse) {
    this.toast.relayMessage(itemKey, result);
  }
}
